import React from "react";
import PsFieldError from "./PsFieldError";

export default function PsLabel({ label, children, meta }) {
  return (
    <div className="form-group">
      <label htmlFor="name">{label}</label>
      {children}
      <PsFieldError meta={meta} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/PsLabel.js